/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimeOffContextRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetTimeOffContextResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getTimeOffContext = (request: GetTimeOffContextRequest, options?: CashRequestOptions) => post<GetTimeOffContextRequest, GetTimeOffContextResponse>("/2.0/cash/get-time-off-context", request, {...options, rejectOnError: true })